(function (window, undefined) {

    function TableauViz(args) {
        this.dashboard;
        this.defaults = {
            embedUrl: '',
            defaultDashboardName: '',
            embedElemId: 'embed-elem',
            embedWidth: 1220,
            embedHeight: 3100 //Note: this must be minimum same height as actual Tableau document, else iFrame will render with scrollbars
        };

        this.options = extend({}, this.defaults, args);

        //Elements
        this.embedElem = document.getElementById(this.options.embedElemId);
        var embedUrl = this.options.embedUrl + '/' + this.options.defaultDashboardName;

        var tableauOptions = {
            width: this.options.embedWidth,
            height: this.options.embedHeight,
            hideToolbar: true,
            hideTabs: true,
            device: 'desktop'
        };

        this.dashboard = new tableau.Viz(this.embedElem, embedUrl, tableauOptions);
    }

    window.BOCSAR = window.BOCSAR || {};
    window.BOCSAR.TableauViz = TableauViz;

})(window);
